const removeCancellationInvoices = (invoicesList) => {
  /**
   * We are given an invoicesList that may have "duplicate" invoices that were created
   * because the user edited one or more of the invoices. We identify the duplicates because
   * they have the same folioId as the original. We also know that the most recent edit has
   * iinvoice.type "Correction" and the latest invoice.created timestamp.
   * We want to return a list that contains only one invoice for each unique folioId
   */
  const filteredInvoiceList = [];

  const folioIds = invoicesList.map((invoice) => invoice.folioId);
  const uniqueFolioIds = new Set(folioIds);

  uniqueFolioIds.forEach((uniqueFolioId) => {
    // 1. Get all the invoices with that id
    const matchingInvoices = invoicesList.filter(
      (invoice) => invoice.folioId === uniqueFolioId,
    );

    const initialInvoice = matchingInvoices.find(
      (invoice) => invoice.type === 'Initial',
    );

    // 2. From those that match, filter those that say have "type": "Correction"
    //    Since we want the invoice with the latest timestamp (i.e. the most recent edit) we sort
    //    by invoice.created
    const editedInvoices = matchingInvoices
      .filter((invoice) => invoice.type === 'Correction')
      .sort(
        (invoiceA, invoiceB) => new Date(invoiceB.created) - new Date(invoiceA.created),
      );

    // 3. Add the latest corrected invoice if it exists, or the initial invoice, to result
    // NOTE: Add initialCreatedAt property to be the created of initial, used to sort final list
    if (editedInvoices.length > 0) {
      filteredInvoiceList.push({
        ...editedInvoices[0],
        initialCreatedAt: initialInvoice.created,
      });
    } else {
      filteredInvoiceList.push({
        ...initialInvoice,
        initialCreatedAt: initialInvoice.created,
      });
    }
  });

  // 4. Sort the filtered invoices by invoice.initialCreatedAt, which is the timestamp the first invoice was
  //    created at. This is the most likely order the user will expect the invoices to be in
  return filteredInvoiceList.sort(
    (invoiceA, invoiceB) => new Date(invoiceA.initialCreatedAt) - new Date(invoiceB.initialCreatedAt),
  );
};

export default removeCancellationInvoices;
